import { useEditor } from "@smartfire/js-block-engine";
import { useCallback, useEffect, useState } from "react";

export const useHorizontalScroll = (ref) => {
  const { isEditing } = useEditor();
  const [scrollTimer, setScrollTimer] = useState();

  const startScrolling = useCallback(
    (side) => {
      if (!ref?.current) return;
      setScrollTimer(
        setInterval(() => {
          ref.current.scrollLeft += 5 * (side === "left" ? -1 : 1);
        }, 10)
      );
    },
    [ref]
  );

  const stopScrolling = useCallback(
    (e) => {
      if (scrollTimer) {
        e.preventDefault();
      }
      setScrollTimer((t) => clearInterval(t));
    },
    [scrollTimer]
  );

  useEffect(() => {
    if (isEditing) return;

    window.addEventListener("mouseup", stopScrolling);
    window.addEventListener("touchend", stopScrolling, { passive: false });
    window.addEventListener("dragend", stopScrolling);
    window.addEventListener("selectionchange", stopScrolling);

    return () => {
      window.removeEventListener("mouseup", stopScrolling);
      window.removeEventListener("touchend", stopScrolling, { passive: false });
      window.removeEventListener("dragend", stopScrolling);
      window.removeEventListener("selectionchange", stopScrolling);
    };
  }, [isEditing, stopScrolling]);

  return { startScrolling };
};
